import MenuButton from 'components/core/Button/MenuButton';
import ScreenAdapter, { ScreenConstraint } from 'components/core/ScreenAdapter';
import { HStack, Spacer, VStack } from 'reaction';
import brand from 'assets/branding/Viraj Shah Logo.png';
import styles from './NewHomepage.module.css';

export default function NewHomepage() {
    return (
        <VStack className={styles.Homepage} justify='center'>
            <Spacer />
            <img src={brand} alt='Viraj Shah Brand' className={styles.BrandImage} />
            <Spacer />
            <ScreenAdapter>
                <ScreenConstraint minHeight={500}>
                    <VStack height='auto'>
                        <MainMenu />
                    </VStack>
                </ScreenConstraint>
                <ScreenConstraint maxHeight={459}>
                    <HStack>
                        <MainMenu />
                    </HStack>
                </ScreenConstraint>
            </ScreenAdapter>
            <Spacer />
            <HStack className={styles.ComplianceBar}>
                <a href='/#/legal'>Legal</a>
                <a href='https://github.com/VirajShah21'>GitHub</a>
                <a href='https://www.linkedin.com/in/viraj-shah-21/'>LinkedIn</a>
                <a href='/#/dmca'>DMCA</a>
                <a href='/#/compliance'>Compliance</a>
                <a href='/#/cookie-policy'>Cookie Policy</a>
                <a href='/#/accessibility'>Accessibility Options</a>
                <Spacer />
                <a href='/#/legal'>&copy; Copyright, Viraj Shah {new Date().getFullYear()}</a>
            </HStack>
        </VStack>
    );
}

function MainMenu() {
    return (
        <>
            <MenuButton href='#/services'>Services</MenuButton>
            <MenuButton href='#/portfolio'>Portfolio</MenuButton>
            <MenuButton href='/'>About</MenuButton>
            <MenuButton href='#/private'>Private</MenuButton>
        </>
    );
}
